import {
  compactFormat,
  dimension,
  dimensionSelector,
  legendPosition,
  palette,
  primaryMetric,
  primaryMetricSelector,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.COMPARISON, FAMILY.DISTRIBUTION],
  recommendedFamily: [FAMILY.COMPARISON, FAMILY.DISTRIBUTION],
  title: "Dumbbell Plot Horizontal",
  defaultHeight: 6,
  controls: [dimension, primaryMetric],
  settings: {
    palette,
    legendPosition: { ...legendPosition, gridPosition: [3, 0] },
    compactFormat: { ...compactFormat, gridPosition: [4, 0] },
    showItems: { ...showItems, gridPosition: [2, 0] },

    decompositionMetric: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    displayMetric: {
      default: "ctr",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      apiParameter: "statistic",
      gridPosition: [1, 0],
      tooltipOrder: 1,
      isStatistic: true,
    },

    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },

    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "displayMetric",
    },

    dimensionSelector: { ...dimensionSelector, gridPosition: [5, 0] },
    primaryMetricSelector: { ...primaryMetricSelector, gridPosition: [6, 0] },
  },
  planSettings: {
    palette,
    legendPosition: { ...legendPosition, gridPosition: [3, 0] },
    compactFormat: { ...compactFormat, gridPosition: [4, 0] },
    showItems: { ...showItems, gridPosition: [2, 0] },

    decompositionMetric: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    displayMetric: {
      default: "ctr",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      apiParameter: "statistic",
      gridPosition: [1, 0],
      tooltipOrder: 1,
      isStatistic: true,
    },

    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },

    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "displayMetric",
    },

    dimensionSelector: { ...dimensionSelector, gridPosition: [5, 0] },
    primaryMetricSelector: { ...primaryMetricSelector, gridPosition: [6, 0] },
  },
};
